const prefix = 'table-formatters';

export const tableI18n = {
    active: {
        id: `${prefix}.active`,
        defaultMessage: 'Active',
    },
    inactive: {
        id: `${prefix}.inactive`,
        defaultMessage: 'Inactive',
    },
    archived: {
        id: `${prefix}.archived`,
        defaultMessage: 'Archived',
    },
    accessPublic: {
        id: `${prefix}.accessPublic`,
        defaultMessage: 'Public',
    },
    accessPrivate: {
        id: `${prefix}.accessPrivate`,
        defaultMessage: 'Private',
    },
    notAvailable: {
        id: `${prefix}.notAvailable`,
        defaultMessage: 'N/A',
    },
} as const;
